import { lazy } from 'react'

export const GetInTouchVariant1 = lazy(() => import('./GetInTouchVariant1'))
